import '@mdxeditor/editor/style.css';
import {
  BoldItalicUnderlineToggles,
  ListsToggle,
  MDXEditor as MDXEditorComp,
  MDXEditorMethods,
  MDXEditorProps,
  diffSourcePlugin,
  headingsPlugin,
  listsPlugin,
  quotePlugin,
  thematicBreakPlugin,
  toolbarPlugin,
} from '@mdxeditor/editor';
import React from 'react';

const toolbarContents = () => (
  <>
    <ListsToggle options={['bullet']} />
    <BoldItalicUnderlineToggles />
  </>
);

export const MDXEditor = React.forwardRef(
  (props: MDXEditorProps & React.RefAttributes<MDXEditorMethods>, ref) => {
    return (
      <MDXEditorComp
        contentEditableClassName="bg-transparent min-h-[100px] richtext-container"
        plugins={[
          ...(props.readOnly ? [] : [toolbarPlugin({ toolbarContents })]),
          headingsPlugin(),
          listsPlugin(),
          quotePlugin(),
          thematicBreakPlugin(),
          diffSourcePlugin({
            diffMarkdown: 'An older version',
            viewMode: 'rich-text',
          }),
        ]}
        {...props}
        ref={ref as React.RefObject<MDXEditorMethods>}
      />
    );
  },
);
